// 1215190327698095 new file
(function () {
    function initHeroObserver() {
      var hero = document.querySelector('.image-hero');
      if (!hero) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            document.body.classList.remove('hero-passed');
          } else {
            document.body.classList.add('hero-passed');
          }
        });
      }, { threshold: 0 });

      observer.observe(hero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroObserver);
    } else {
      initHeroObserver();
    }
  })();